import React, { useState } from "react";
import {
    useStripe,
    useElements,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
} from "@stripe/react-stripe-js";
import "../../../assets/scss/subscription.scss";
import Repository from "../../../configs/axios/repository";
import { useSelector } from "react-redux";
import { getAuth } from "../../../redux/selectors";
import { encrypt } from "../../../utility/helpers/encrypt";
import { useHistory } from "react-router-dom";
import { handlePlanState } from "../../../redux/layout";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const CheckoutForm = ({
    setShowForm,
    priceId,
    productId,
    setLoadingData,
    setShowError,
    trialDaysCount,
    couponId,
    setWarning,
    warning,
}) => {
    const [cardName, setCardName] = useState("");
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const { userData } = useSelector(getAuth);
    const history = useHistory();
    const dispatch = useDispatch();

    const JoinCreditCard = async (payload) => {
        setLoadingData(false);
        let cardInfo = {
            userData: userData.userId,
            curdName: cardName,
            source: payload,
        };

        const result = await Repository.postRequest(
            `api/users/addUserPaymentData`,
            cardInfo
        );

        if (result.data.success === true) {
            let planInfo = {
                default_payment_method: productId[1].default_price,
                priceId: priceId,
                trialPeriod: trialDaysCount,
                couponId: couponId,
            };

            const createSubscription = await Repository.postRequest(
                "api/users/createSubscription",
                {
                    ...planInfo,
                    userId: userData.userId,
                }
            );

            setLoadingData(true);
            if (createSubscription.data.success) {
                if (
                    createSubscription.data.data.status === "active" ||
                    createSubscription.data.data.status === "trialing"
                ) {
                    localStorage.setItem(
                        "planState",
                        createSubscription.data.data.status
                    );
                    dispatch(
                        handlePlanState(createSubscription.data.data.status)
                    );
                    history.push(
                        `/subscriptionCompleted/${encrypt(
                            JSON.stringify({
                                subscriptionId: createSubscription.data.data.id,
                                priceId: createSubscription.data.data.plan.id,
                            })
                        )}`
                    );
                } else if (
                    createSubscription.data.data.status === "incomplete"
                ) {
                    localStorage.setItem("planState", "incomplete");
                    dispatch(
                        handlePlanState(createSubscription.data.data.status)
                    );
                    Swal.fire({
                        text: "Transaction declined: Insufficient funds. Please add funds or use a different payment method.",
                        icon: "warning",
                        confirmButtonColor: "#16285e",
                    });
                }
            }
        } else {
            if (result.data.data == "Your card has insufficient funds.") {
                setWarning(result.data.data);
            }
        }
        setLoadingData(true);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        setWarning(null);
        if (productId && priceId) {
            setShowError(false);
            if (!stripe || !elements) {
                return;
            }

            const cardElement = elements.getElement(CardNumberElement);

            try {
                const { token, error } = await stripe.createToken(cardElement);

                if (error) {
                    setError(error.message);
                } else {
                    JoinCreditCard(token.id);
                }
            } catch (error) {
                console.error("Error creating token:", error);
            }
        } else {
            setShowError(true);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="checkout-form">
            <label htmlFor="card_name" className="label">
                Name On Card
            </label>
            <div className="form-name">
                <input
                    className="input"
                    type="text"
                    id="card_name"
                    name="card_name"
                    onChange={(e) => setCardName(e.target.value)}
                    placeholder="Name On Card"
                />
            </div>
            <label className="label">Card Number</label>
            <div className="form-row">
                <div id="card_number">
                    <CardNumberElement />
                </div>
            </div>
            <label className="label">Expiration</label>
            <div className="form-row">
                <div>
                    <div id="card_expiry">
                        <CardExpiryElement />
                    </div>
                </div>
            </div>
            <label className="label">CVC</label>
            <div className="form-row af">
                <div>
                    <div id="card_cvc">
                        <CardCvcElement />
                    </div>
                </div>
            </div>
            {/* <label htmlFor="csv" className="label">
                Referral Code
            </label>
            <div className="form-referalCode ">
                <div>
                    <input
                        className="input"
                        type="text"
                        id="csv"
                        name="csv"
                        placeholder="Referral Code"
                    />
                </div>
            </div> */}
            {error && <p className="error-message">{error}</p>}
            {warning ? <p className="error-message">{warning}</p> : ""}
            <div className="subBtn mt-1">
                <button
                    onClick={() => setShowForm(false)}
                    type="button"
                    className="cancelSub"
                >
                    Cancel
                </button>

                <button className="btnNextSub" type="submit" disabled={!stripe}>
                    Submit
                </button>
            </div>
        </form>
    );
};

export default CheckoutForm;
